import { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './resetPassword.module.scss'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonText from '@/components/_custom/Buttons/ButtonText/ButtonText'
import { REQUEST_CHANGE_PASSWORD } from '@/modules/API/software/passwordHandler'
import { useMutation } from '@apollo/client'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'

interface resetPasswordDialogProps {
    email: string
    open: boolean
    handleClose: () => void
    parent?: boolean
}

const ResetPasswordDialog: FunctionComponent<resetPasswordDialogProps> = ({
    email,
    open,
    handleClose,
    parent = false
}: resetPasswordDialogProps) => {
    const { t } = useTranslation()

    const [requestPasswordComplete, setRequestPasswordComplete] = useState<boolean>(false)
    const [requestPasswordError, setRequestPasswordError] = useState<boolean>(false)

    const [requestChangePassword] = useMutation(REQUEST_CHANGE_PASSWORD, {
        variables: {
            email
        },
        onCompleted: (): void => {
            setRequestPasswordComplete(true)
        },
        onError: (): void => {
            setRequestPasswordError(true)
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('forgottenPassword')} parent={parent} />
            <DialogBody>
                <div className={styles.DialogBody}>
                    {requestPasswordComplete && (
                        <div className={styles.TextContainer}>
                            <p className={styles.Text}>
                                {t('passwordResetTextSuccess')} <span className={styles.TextColor}> {email} </span>
                            </p>
                            <p className={styles.Text}>{t('passwordResetTextSuccessPart2')}</p>
                        </div>
                    )}
                    {requestPasswordError && <p className={styles.Text}>{t('changePasswordResetError')}</p>}
                    {!requestPasswordComplete && !requestPasswordError ? (
                        <>
                            <p className={styles.Text}>{t('resetPassword')}</p>
                            <div className={styles.ButtonContainer}>
                                <ButtonTextIcon
                                    type={'close'}
                                    onClick={handleClose}
                                    parent={parent}
                                    className={styles.Button}
                                    fullWidth
                                />
                                <ButtonTextIcon
                                    type={'reset'}
                                    onClick={requestChangePassword}
                                    parent={parent}
                                    className={styles.Button}
                                    fullWidth
                                />
                            </div>
                        </>
                    ) : (
                        <ButtonText
                            text={t('close')}
                            onClick={handleClose}
                            parent={parent}
                            className={styles.Button}
                            fullWidth
                        />
                    )}
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ResetPasswordDialog
